const { BASE_URL } = require("./client");

const GET_GLOBAL_EXPANSION_DATA = BASE_URL + "/api/globalexpansionform";
const POST_GLOBAL_EXPANSION_DATA = BASE_URL + "/api/globalexpansionform";
const UPDATE_GLOBAL_EXPANSION_DATA = BASE_URL + "/api/globalexpansionform";
const DELETE_GLOBAL_EXPANSION_DATA = BASE_URL + "/api/globalexpansionform";

module.exports = {
  GET_GLOBAL_EXPANSION_DATA,
  POST_GLOBAL_EXPANSION_DATA,
  UPDATE_GLOBAL_EXPANSION_DATA,
  DELETE_GLOBAL_EXPANSION_DATA,
};
